import OgImage from '~/shared/images/og-image.png';

export const SEO_TITLE =
  '%%TITLE%%. CRE - Портал коммерческой недвижимости Москвы и России. Журнал Commercial Real Estate. Новости и обзоры рынка недвижимости.';
export const SEO_DESCRIPTION =
  'CRE.RU: Обзоры рынка коммерческой недвижимости - новости, статьи, исследования, аналитические материалы и интервью в журнале Commercial Real Estate. Все о бизнес центрах, ритейле, офисных, торговых, складских и нежилых  помещениях.';

export const SEO_TAG_TITLE = '%%TAG%% - публикации cre.ru';
export const SEO_TAG_DESCRIPTION =
  '%%TAG%%. CRE - Портал коммерческой недвижимости Москвы и России. Журнал Commercial Real Estate. Новости и обзоры рынка недвижимости.';

export const OG_TYPE = 'website';
export const OG_SITE_NAME = 'CRE.ru';
/* Size of the default og-image.png */
export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_HEIGHT = 630;

export function stripHtml(value: string | null | undefined): string {
  return (value ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/* Vite asset imports are already absolute on the client — can't just prefix origin */
export function getAbsoluteUrl(
  origin: string,
  value: string | null | undefined,
): string | undefined {
  if (!value) {
    return undefined;
  }

  return value.startsWith('http') ? value : `${origin}${value}`;
}

/*
 * API images come without dimensions and vary in size, so width/height are
 * only set for the default image — a wrong size is worse than none
 */
export function getOgImageMeta(
  origin: string,
  image?: string | null,
): { property: string; content: string }[] {
  const imageUrl = getAbsoluteUrl(origin, image);
  const content = imageUrl ?? getAbsoluteUrl(origin, OgImage) ?? OgImage;

  return ['og', 'vk'].flatMap((prefix) => [
    { property: `${prefix}:image`, content },
    ...(imageUrl
      ? []
      : [
          {
            property: `${prefix}:image:width`,
            content: String(OG_IMAGE_WIDTH),
          },
          {
            property: `${prefix}:image:height`,
            content: String(OG_IMAGE_HEIGHT),
          },
        ]),
  ]);
}
